module.exports = __webpack_public_path__ + "static/media/login.75853c4c.jpg";